import { Card } from '@/components/ui/card';
import { ChevronRight, GraduationCap } from 'lucide-react';
import React from 'react';

export const LearnBanner: React.FC = () => (
  <Card
    className="flex-row w-full cursor-pointer items-center gap-3 border-t-2 border-t-[#2d6c7a] px-3 py-3 sm:gap-4 sm:px-4 sm:py-4 md:gap-5 md:px-6 md:py-6 transition-colors hover:bg-muted/50"
    onClick={() => {
      window.location.href = '/learn';
    }}
  >
    <GraduationCap className="size-8 shrink-0 text-[#2d6c7a] sm:size-10 md:size-14" />
    <p className="text-sm flex-1 font-semibold text-foreground sm:text-base md:text-xl">
      Start learning now with our online articles, videos, and more.
    </p>
    <ChevronRight className="size-4 shrink-0 text-muted-foreground sm:size-5 md:size-7" />
  </Card>
);
